import Vue from 'vue';
import VueResource from 'vue-resource';

import AuthorRecentArticles from './vue-components/author-recent-articles';

Vue.use(VueResource);

/**
 * export
 * @return {Vue} The Vue instance.
 */
export default function() {
	const authorRecentArticles = document.querySelector(
		'#mg-author-recent-articles'
	);

	if (!authorRecentArticles) return;

	Vue.config.productionTip = false;

	return new Vue({
		el: authorRecentArticles,
		render: h => {
			return h(AuthorRecentArticles, {
				props: {
					id: authorRecentArticles.getAttribute('data-author-id')
				}
			});
		}
	});
}



// WEBPACK FOOTER //
// ./assets/src/js/components/author-recent-articles.js